import { FilterWorkflowComponent } from './common/filtercomponent';
import { Provider, WorkflowComponentParamType } from '../types';
import dedent from 'ts-dedent';
class TableFilter extends FilterWorkflowComponent {
    constructor() {
        super({
            name: 'native.where',
            group: 'Data Preparation',
            title: 'Where',
            description: `
      This component filters an input table according to a WHERE expression.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'expression',
                type: WorkflowComponentParamType.StringSql,
                title: 'Filter expression',
                placeholder: 'E.g.: area > 1000 AND area < 3000'
            }
        ]);
        this.requiresDynamicSQL = true;
    }
    async _getMatchCode(params, envVars, workflow, componentName, connection, codeType, schema) {
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
        *
      FROM ${connection.quoteName(params.source)}
      WHERE ${params.expression}`;
        }
        else {
            return dedent `SELECT *
      FROM ${connection.quoteName(params.source)}
      WHERE ${params.expression}`;
        }
    }
    async _getUnmatchCode(params, matchTablename, envVars, workflow, componentName, connection, codeType, schema) {
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
        *
      FROM ${connection.quoteName(params.source)}
      WHERE NOT ${params.expression}`;
        }
        else {
            return dedent `SELECT *
      FROM ${connection.quoteName(params.source)}
      WHERE NOT ${params.expression}`;
        }
    }
}
export { TableFilter };
